// extracted by mini-css-extract-plugin
export default {"input":"TasksTableTbodyField_input__teGUY","error":"TasksTableTbodyField_error__GsXlU"};